export default __webpack_public_path__ + "1gm3C-0-register_account.svg";